import { Cookies } from "react-cookie";
export const USER_TOKEN = "ADMIN_TOKEN";

const cookies = new Cookies();

export const setToken = (value) => {
  if (value) {
    cookies.set("token_hgsunflower", value, {
      path: "/",
      maxAge: 1 * 24 * 60 * 60 * 1000, // 1 days
      secure: true,
      domain: ".sunflowerhagiang.com",
      sameSite: "lax"
    });
  }
};

export const clearToken = () =>
  cookies.remove("token_hgsunflower", {
    path: "/",
    secure: true,
    domain: ".sunflowerhagiang.com",
    sameSite: "lax"
  });

export const getToken = () => {
  const value = cookies.get("token_hgsunflower");
  return value ? value : "";
};

export const urlMain = "https://sunflowerhagiang.com";
